module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b426caa86e283eeef95134cede917635.png";